// extracted by mini-css-extract-plugin
module.exports = {"roundBackground":"Icon_roundBackground__ch-pa","middle":"Icon_middle__f2fT1","big":"Icon_big__3g0yZ"};